import A from './types';

const initialState = {
  saveContactInfo: {},
  userAccountInfo: {
    loading: false,
    error: false,
    data: [],
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.USER_ACCOUNT_INFO: { // user account page infomation
      if (action.pending) {
        return {
          ...state,
          userAccountInfo: {
            loading: true,
            error: false,
            // data: {},
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          userAccountInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        userAccountInfo: {
          loading: false,
          error: action.payload.message,
          // data: {},
        },
      };
    }
    case A.USER_ACCOUNT_INFO_INIT: {
      return {
        ...state,
        userAccountInfo: {
          loading: false,
          error: false,
          data: [],
        },
      };
    }
    case A.SAVE_USER_CONTACT_INFO: {
      if (action.pending) {
        return {
          ...state,
          saveContactInfo: {
            loading: true,
            disable: true,
            error: false,
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          saveContactInfo: {
            loading: false,
            disable: false,
            error: 'Update Successful',
          },
        };
      }
      return {
        ...state,
        saveContactInfo: {
          loading: false,
          disable: true,
          error: action.payload.message,
        },
      };
    }
    case A.USER_ACCOUNT_PAGE_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
          childError: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/userAccountPage/reducer.js